import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';

import vtConfig from '../../../../config';
import { ActionHandlers } from '../hooks/useHandlers';
import useNotificationPosition from '../hooks/useNotificationPosition';

import { ButtonsWrapper, DiscardButton, SaveButton, SavingSpinner, UpgradeDescription, Wrapper } from './Wrapper';

type SaveBlockProps = {
  wasChanged: boolean;
  getHandlers: () => ActionHandlers;
  shouldUpgrade?: boolean;
  upgradeDescription?: string;
};

const SaveBlock: FC<SaveBlockProps> = ({ wasChanged, getHandlers, upgradeDescription, shouldUpgrade = false }) => {
  const [notificationPosition] = useNotificationPosition();
  const { save, discard, isPending } = getHandlers();

  const pricingUrl = `${vtConfig().urls.wave}pricing`;
  const upgradeLink = getUpgradeLinkProps(pricingUrl);

  const saveButtonUrl = shouldUpgrade ? upgradeLink.href : '';
  const saveButtonText = shouldUpgrade ? 'Upgrade to save' : 'Save changes';

  if (!wasChanged) return null;

  return (
    <Wrapper position={notificationPosition} {...{ isPending }}>
      <ButtonsWrapper>
        {!isPending ? (
          <>
            <DiscardButton size="medium" variant="link" onClick={discard}>
              Discard
            </DiscardButton>
            <SaveButton
              {...(saveButtonUrl && !upgradeLink.onClick && { href: saveButtonUrl })}
              size="medium"
              variant="green"
              onClick={shouldUpgrade ? upgradeLink.onClick : save}
              {...{ isPending }}
            >
              {saveButtonText}
            </SaveButton>
          </>
        ) : (
          <SavingSpinner>Saving</SavingSpinner>
        )}
      </ButtonsWrapper>
      {shouldUpgrade && upgradeDescription && <UpgradeDescription>{upgradeDescription}</UpgradeDescription>}
    </Wrapper>
  );
};

export default SaveBlock;
